<template>
  <v-dialog :value="value" max-width="520" @input="$emit('input', $event)">
    <v-card v-if="row">
      <v-card-title class="text-subtitle-1 font-weight-medium">
        {{ row.groupTitle }} · {{ row.label }}
        <v-chip small class="ml-3" :color="meta.color" :text-color="meta.textColor">{{ meta.label }}</v-chip>
      </v-card-title>
      <v-card-text>
        <div class="module_scheme_slot_details__row">
          <span class="module_scheme_slot_details__caption">Позиция (снимок на момент покупки)</span>
          <template v-if="row.chosen">
            <div class="font-weight-medium">{{ row.chosen.name || "…" }}</div>
            <div v-if="row.chosen.vendorCode" class="text-caption grey--text">
              Артикул: {{ row.chosen.vendorCode }}
            </div>
          </template>
          <div v-else class="grey--text">не выбрана</div>
        </div>

        <div class="module_scheme_slot_details__row">
          <span class="module_scheme_slot_details__caption">Количество и цена</span>
          <div>
            {{ row.quantity }} шт.
            <template v-if="row.chosen && row.chosen.price !== null">
              × {{ money(row.chosen.price) }} = <b>{{ money(row.chosen.price * row.quantity) }}</b>
            </template>
            <span v-else class="grey--text">· цена не зафиксирована</span>
          </div>
        </div>

        <div class="module_scheme_slot_details__row">
          <span class="module_scheme_slot_details__caption">Условия подбора (снимок узла)</span>
          <template v-if="constraints.length">
            <v-chip v-for="text in constraints" :key="text" x-small label class="mr-1 mb-1">{{ text }}</v-chip>
          </template>
          <div v-else class="grey--text">условий не было</div>
        </div>

        <div v-if="objectName" class="module_scheme_slot_details__row">
          <span class="module_scheme_slot_details__caption">Объект</span>
          <div>{{ objectName }}</div>
        </div>

        <div v-if="row.db && row.db.id_document" class="module_scheme_slot_details__row">
          <span class="module_scheme_slot_details__caption">Подтверждающий документ</span>
          <div>№ {{ row.db.id_document }}</div>
        </div>

        <v-alert type="info" text dense class="mt-4 mb-0 text-caption">
          Слот заморожен: позицию, количество, условия и объект изменить нельзя. Дальше меняется только статус.
        </v-alert>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="$emit('input', false)">Закрыть</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { SLOT_STATUS, formatRule } from "@/helpers/moduleSchemeSlots";

/** Карточка замороженного слота (куплено / установлено): только просмотр. */
export default {
  name: "ModuleSchemeSlotDetails",
  props: {
    value: { type: Boolean, default: false },
    // строка слота или запись «нет на чертеже» (см. buildSlotGroups)
    row: { type: Object, default: null },
    // объект, за которым закреплён слот (у купленного — на момент покупки)
    objectName: { type: String, default: "" },
  },
  computed: {
    meta() {
      return SLOT_STATUS[this.row && this.row.status] || SLOT_STATUS.draft;
    },
    constraints() {
      return ((this.row && this.row.constraints) || []).map(formatRule);
    },
  },
  methods: {
    money(value) {
      return new Intl.NumberFormat("ru-RU", { style: "currency", currency: "RUB", maximumFractionDigits: 2 }).format(
        value
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.module_scheme_slot_details {
  &__row {
    margin-bottom: 14px;
  }
  &__caption {
    display: block;
    margin-bottom: 2px;
    font-size: 0.75em;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: rgba(0, 0, 0, 0.6);
  }
}
</style>
